import { Component, OnInit } from '@angular/core';

import {Platform, AlertController, NavController} from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import {Router} from '@angular/router';
import {ThemeService} from './services/custom-color/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  // public selectedIndex = 0;
  // public menu = [
  //   {
  //     title: 'Home',
  //     url: '/folder/Home'
  //   },
  //   {
  //     title: 'Account',
  //     url: '/folder/account/Account'
  //   }
  // ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public alertCtrl: AlertController,
    public router: Router,
    public nav: NavController
  ) {
    this.initializeApp();
    //console.log("app components router",this.router.url);
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is("ios")){
        this.statusBar.styleDefault()
        this.statusBar.overlaysWebView(true);
      }else{
        this.statusBar.styleLightContent()
      }
      this.splashScreen.hide();
    });
  }

  ngOnInit() {
    /*var user = JSON.parse(localStorage.getItem("user"));
    if (user != undefined && user != null && user.session != false){
      this.router.navigateByUrl("/tabs/home");
    }*/
  }
}
